function afterDecimal(num) {
    if (Number.isInteger(num)) {
        return 0;
    }
    return num.toString().split('.')[1].length;
}

$.fn.animateNumber = function(options) {
    var number = $(this).data("number");
    var digitsAfter = afterDecimal(number);
    var settings = $.extend({
        digits: digitsAfter,
        stepFunction: function(now) {
            if (settings.digits > 0) {
                $(this).text(now.toFixed(settings.digits).toString().replace(".", ","));
            } else {
                $(this).text(Math.ceil(now));
            }
        }
    }, options );
    $(this).prop('Counter',0).animate({
        Counter: number
    }, {
        duration: 2000,
        easing: 'swing',
        step: settings.stepFunction
    });
}

function initScrollEffects(){
    var $scrollEffects = $('.scroll-effect');
    if ($scrollEffects) {
        var controller = new ScrollMagic.Controller();
        var scenes = [];
        $scrollEffects.each(function (idx) {
            scenes[idx] = new ScrollMagic.Scene({
                triggerElement: this,
                reverse: false,
                triggerHook: "onEnter"
            })
                .on("enter", function(e) {
                    $(e.target.triggerElement()).animateNumber();
                })
                .addTo(controller);
        });
    }
}